import React, { useState } from "react";
import { FilterContainer } from "./FilterContainer";
import { ProductContainer } from "./ProductContainer";
import { ProductSorting } from "./ProductSorting";
import { toggleFilterPanel } from "./HelperFunctions";
import { perfEntries } from './Constants'

export const CategoryContainer = () => {
    var [isLoading, setItemsLoading] = useState(false);
    const [itemGroups, setItemGroups] = useState(model.itemGroupModel);
    const [pagedItemGroups, setPagedItemGroups] = useState(itemGroups);

    const mobileFilteringOn = $(window).innerWidth() < 768 && model.filterReponseInfo.TotalFiltersCount > 0;
    const isSearch = model.SectionTitle.substring(0, 7) == "Search ";

    return (
        <>
            <div className="tw-mt-[14px]" id="CategoryContainer" className="tw-flex-col">
                <div className={"tw-flex tw-flex-col md:tw-flex-row tw-mb-[14px] tw-w-full" + (isSearch ? "md:tw-h-[67px]" : "md:tw-h-[50px]")}>
                    <h1 className={"CategoryTitle tk-trade-gothic-next-condensed xl:tw-text-[20px] xxl:tw-text-[36px] " + (isSearch ? "tw-mt-[25px] xxl:tw-mt-[11px]" : "tw-mt-[-10px] md:tw-mt-0")}>
                        {model.SectionTitle}
                    </h1 >
                    <div className={"tw-flex tw-w-full md:tw-w-auto md:tw-ml-auto md:tw-self-end tw-justify-end md:tw-mb-0 " + (mobileFilteringOn ? "tw-mt-[15px] tw-mb-[35px]" : "")}>
                        {mobileFilteringOn && (
                            <div className="tw-flex tw-col tw-flex-wrap tw-justify-end tw-text-[16px] tk-trade-gothic-next tw-flex-[1_0_50%]" >
                                <div id="filterLabelMobile" className="tw-h-[43px] tw-w-full tw-cursor-pointer tw-font-bold tw-flex tw-justify-center tw-items-center"
                                    onClick={toggleFilterPanel} style={{ border: "solid 1.5px #E0E0E0" }}>

                                    <svg fill="#000000" width="800px" height="800px" viewBox="-2 0 19 19" xmlns="http://www.w3.org/2000/svg" className="cf-icon-svg tw-w-[40px] tw-h-[25px]">
                                        <path d="M14.546 6.201a.554.554 0 0 1-.554.554h-1.79a2.22 2.22 0 0 1-4.298 0H1.008a.554.554 0 0 1 0-1.108h6.896a2.22 2.22 0 0 1 4.299 0h1.789a.554.554 0 0 1 .554.554zm0 3.7a.554.554 0 0 1-.554.554H6.987a2.22 2.22 0 0 1-4.298 0h-1.68a.554.554 0 0 1 0-1.108h1.68a2.22 2.22 0 0 1 4.298 0h7.005a.554.554 0 0 1 .554.554zm0 3.7a.554.554 0 0 1-.554.555h-1.79a2.22 2.22 0 0 1-4.298 0H1.008a.554.554 0 0 1 0-1.109h6.896a2.22 2.22 0 0 1 4.299 0h1.789a.554.554 0 0 1 .554.554zm-8.597-3.7a1.11 1.11 0 1 0-1.111 1.111 1.112 1.112 0 0 0 1.11-1.11zm5.215-3.7a1.111 1.111 0 1 0-1.11 1.11 1.112 1.112 0 0 0 1.11-1.11zm0 7.4a1.111 1.111 0 1 0-1.11 1.111 1.112 1.112 0 0 0 1.11-1.11z" />
                                    </svg>
                                    Filters<span id="mobile-number-filters" style={{ display: "none" }}></span>
                                </div>
                            </div>
                        )}
                        <ProductSorting itemGroups={itemGroups} setItemGroups={setItemGroups} />
                    </div>
                </div>
                <div className="tw-flex">
                    <FilterContainer setItemGroups={setItemGroups} setItemsLoading={setItemsLoading} />
                    <ProductContainer itemGroups={itemGroups} pagedItemGroups={pagedItemGroups} setPagedItemGroups={setPagedItemGroups} isLoading={isLoading} />
                </div>
            </div>
        </>
    );
}

if (!(perfEntries[0].type === 'back_forward') && !window.location.href.includes('products/details')) {
    sessionStorage.clear();
}